import { render, staticRenderFns } from "./_release.vue?vue&type=template&id=9837e9c8&scoped=true&"
import script from "./_release.vue?vue&type=script&lang=js&"
export * from "./_release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9837e9c8",
  null
  
)

export default component.exports